import { render, staticRenderFns } from "./SectionsCrud.vue?vue&type=template&id=4858ab8c"
import script from "./SectionsCrud.vue?vue&type=script&lang=js"
export * from "./SectionsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports